"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeCustomerResultWithTokensToJSON = exports.ChangeCustomerResultWithTokensFromJSONTyped = exports.ChangeCustomerResultWithTokensFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function ChangeCustomerResultWithTokensFromJSON(json) {
    return ChangeCustomerResultWithTokensFromJSONTyped(json, false);
}
exports.ChangeCustomerResultWithTokensFromJSON = ChangeCustomerResultWithTokensFromJSON;
function ChangeCustomerResultWithTokensFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'customer': !(0, runtime_1.exists)(json, 'customer') ? undefined : (0, _1.CustomerDataFromJSON)(json['customer']),
        'tokens': !(0, runtime_1.exists)(json, 'tokens') ? undefined : (0, _1.TokensFromJSON)(json['tokens']),
        'errors': !(0, runtime_1.exists)(json, 'errors') ? undefined : (0, _1.MessagesFromJSON)(json['errors']),
        'warnings': !(0, runtime_1.exists)(json, 'warnings') ? undefined : (0, _1.MessagesFromJSON)(json['warnings']),
    };
}
exports.ChangeCustomerResultWithTokensFromJSONTyped = ChangeCustomerResultWithTokensFromJSONTyped;
function ChangeCustomerResultWithTokensToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'customer': (0, _1.CustomerDataToJSON)(value.customer),
        'tokens': (0, _1.TokensToJSON)(value.tokens),
        'errors': (0, _1.MessagesToJSON)(value.errors),
        'warnings': (0, _1.MessagesToJSON)(value.warnings),
    };
}
exports.ChangeCustomerResultWithTokensToJSON = ChangeCustomerResultWithTokensToJSON;
//# sourceMappingURL=ChangeCustomerResultWithTokens.js.map